import React from 'react'
import PropTypes from 'prop-types'

import useStyles from './styles'
import './style.css'

const GuestLayout = (props) => {
  const classes = useStyles()
  const { children } = props

  return (
    <div id='bg' className={ classes.mainContainer }>
      <div className={ classes.contentScroll }>
        <div className={ classes.contentContainer }>{children}</div>
      </div>
    </div>
  )
}

GuestLayout.propTypes = {
  children: PropTypes.element.isRequired,
}

export default GuestLayout
